import classNames from "classnames";
import PAText from "component/design-system/typography/PAText/PAText";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import isHighTrafficPage from "util/helper/isHighTrafficPage";
import isHomePage from "util/helper/isHomePage";
import { validateVehicle } from "../../../util/vehicle/validate-vehicle";
import VehicleIcon from "../VehicleIcon";
import styles from "./styles.module.scss";

function HomeGarageLabel(props) {
  const { isCompactGarage } = props;
  const selectedVehicle = useSelector((state: RootState) => state.garage.selectedVehicle);
  const { t } = useTranslation("common");

  const router = useRouter();
  const { pathname } = router;
  const isItHomePage = isHomePage(pathname);
  const isItHighTrafficPage = isHighTrafficPage(router);

  return (
    <div className={classNames({
      [styles.compact_garage]: isCompactGarage,
    })}
    >
      <div className="d-flex justify-content-center home-garage-wrapper">
        <div className="d-flex justify-content-center align-items-center home-garage-heading">
          <div>
            <VehicleIcon dark={(isItHomePage || isItHighTrafficPage)} width={38} height={38} />
          </div>
          <PAText
            color={(!isItHomePage && !isItHighTrafficPage) ? "white" : "black"}
            className="p-l-10"
            style={{ fontSize: "calc(1.8 * var(--safari-root-font, 10px))", margin: 0, textWrap: "nowrap" }}
          >
            <strong>
              {validateVehicle(selectedVehicle) ? t("Your vehicle") : t("Select Your Vehicle")}
            </strong>
          </PAText>
        </div>
      </div>

      <div className="home-garage-connector">
        <div className="hookWrapper">
          <div className="circle" />
          <div className="hook" />
        </div>
        <div className="hookWrapper">
          <div className="circle" />
          <div className="hook" />
        </div>
      </div>
    </div>
  );
}

export default HomeGarageLabel;
